/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LotType } from './LotType';
import {
    LotTypeFromJSON,
    LotTypeFromJSONTyped,
    LotTypeToJSON,
} from './LotType';
import type { PortfolioType } from './PortfolioType';
import {
    PortfolioTypeFromJSON,
    PortfolioTypeFromJSONTyped,
    PortfolioTypeToJSON,
} from './PortfolioType';
import type { PositionType } from './PositionType';
import {
    PositionTypeFromJSON,
    PositionTypeFromJSONTyped,
    PositionTypeToJSON,
} from './PositionType';
import type { ReportStage } from './ReportStage';
import {
    ReportStageFromJSON,
    ReportStageFromJSONTyped,
    ReportStageToJSON,
} from './ReportStage';

/**
 * 
 * @export
 * @interface MetaData
 */
export interface MetaData {
    /**
     * 
     * @type {PortfolioType}
     * @memberof MetaData
     */
    portfolioType?: PortfolioType;
    /**
     * 
     * @type {PositionType}
     * @memberof MetaData
     */
    positionType?: PositionType;
    /**
     * 
     * @type {LotType}
     * @memberof MetaData
     */
    lotType?: LotType;
    /**
     * 
     * @type {ReportStage}
     * @memberof MetaData
     */
    reportStage?: ReportStage;
}



/**
 * Check if a given object implements the MetaData interface.
 */
export function instanceOfMetaData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetaDataFromJSON(json: any): MetaData {
    return MetaDataFromJSONTyped(json, false);
}

export function MetaDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioType': !exists(json, 'portfolio_type') ? undefined : PortfolioTypeFromJSON(json['portfolio_type']),
        'positionType': !exists(json, 'position_type') ? undefined : PositionTypeFromJSON(json['position_type']),
        'lotType': !exists(json, 'lot_type') ? undefined : LotTypeFromJSON(json['lot_type']),
        'reportStage': !exists(json, 'report_stage') ? undefined : ReportStageFromJSON(json['report_stage']),
    };
}

export function MetaDataToJSON(value?: MetaData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolio_type': PortfolioTypeToJSON(value.portfolioType),
        'position_type': PositionTypeToJSON(value.positionType),
        'lot_type': LotTypeToJSON(value.lotType),
        'report_stage': ReportStageToJSON(value.reportStage),
    };
}

